import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { AppDispatch } from 'redux/store';
import { paymentType } from 'global/Models/omOrderModel';
import { setOrderPaymentTypes } from 'redux/reducer/ParcelOrder/parcelOrderReducer';

export const getPaymentTypes = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.paymentTypeGetAll, { recordsPerPage: 50 })
    .then((res: IBackendSearchGeneric<paymentType>) => {
      res.isSuccess && dispatch(setOrderPaymentTypes(res.data));
    })
    .catch(() => {});
};
